import { select, take } from '@redux-saga/core/effects';
import { LOAD_CURSORS_SUCCESS } from 'JS/actionCreators/scribeActions';
import getCursorResourcesAndMetadata from 'JS/sagas/sagaHelpers/getCursorResourcesAndMetadata';

export default function* getCursorResourcesAndTimings(scribe) {
  const stateCursors = yield select(state => state.scribes.cursors);
  const cursors = stateCursors.length ? stateCursors : (yield take(LOAD_CURSORS_SUCCESS)).cursors; // If cursors aren't loaded yet, wait until we get them to continue
  const defaultCursor = scribe.cursor;
  const elementCursors = scribe.elements.filter(el => el.cursorId).map(el => el.cursorId);

  const allCursorData = [defaultCursor, ...elementCursors].reduce((all, cursorId) => {
    all[cursorId] = {
      ...getCursorResourcesAndMetadata(cursors, cursorId)
    };
    return all;
  }, {});

  return allCursorData;
}
